import { Injectable, ComponentFactoryResolver } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';

import * as _ from 'lodash';
import { DashboardQueries } from '../enums/DashboardQueries';
import { WidgetSearch } from '../models/WidgetSearch';
import { DispatchRefTrackSearch } from '../models/DispatchRefTrackSearch';
import { BehaviorSubject, Subject } from 'rxjs';
import { DashboardLayoutsBusParam } from '../models/DashboardLayoutsBusParam';
import { SearchTarget } from '../enums/SearchTarget';
import { DispatchData } from '../models/DispatchData';
import { CreditMemoWidgetUser } from '../models/CreditMemoWidgetUser';
import { FeatureFlagService } from './feature-flag.service';
import { GlobalsService } from './globals.service';
import { DispatchQVSettingsInput } from '../models/DispatchQVSettingsInput';
import { DQOIDisplaySettings } from '../models/DQOIDisplaySettings';

@Injectable()
export class DashboardService extends BaseService {

    constructor(_http: HttpClient, public featureFlagService: FeatureFlagService, globals: GlobalsService) {
        super(_http);
        this.baseUrl = this.rootUrl + "Dashboard/";
        this.baseUrl_v2 = this.rootUrl_v2 + "Dashboard/";
        this.getCreditMemoWidgetUser(globals.userId).subscribe(data => {
            this.creditMemoUser = data.result;
        })
    }

    private refreshTrigger = new Subject<boolean>();
    refreshTrigger$ = this.refreshTrigger.asObservable();

    private dispatchReviewRefresh = new Subject<boolean>();
    dispatchReviewRefresh$ = this.dispatchReviewRefresh.asObservable();

    private dispatchRefrigRefresh = new Subject<boolean>();
    ddispatchRefrigRefresh$ = this.dispatchRefrigRefresh.asObservable();

    private generalWidgetRefresh = new Subject<boolean>();
    generalWidgetRefresh$ = this.generalWidgetRefresh.asObservable();

    widgets: any = [];
    private widgetsChanged = new BehaviorSubject<any>(this.widgets);
    widgetsChanged$ = this.widgetsChanged.asObservable();

    public featureFlagCreditMemoApprovalWidgetHighPriorityChangesPt2: boolean = false;

    creditMemoUser: CreditMemoWidgetUser;

    disableDragging: boolean = false;

    manRefresh() {
        this.refreshTrigger.next(true);
    }

    dispQVClosed() {
        //  this.dispatchReviewRefresh.next( true );
    }

    dispRefrigQVClosed() {
        //  this.dispatchRefrigRefresh.next( true );
    }
    generalWidgetClosed() {
        //  this.generalWidgetRefresh.next(true);
    }
    setWidgets(widgets: any) {
        this.widgetsChanged.next(widgets);
    }

    private openDQOI = new Subject<any>();
    openDQOI$ = this.openDQOI.asObservable();

    openDQOIPopup(id: string, target?: SearchTarget, dqoiDisplaySettings?: DQOIDisplaySettings) {
        if (target) {
            let targetObj: DispatchData = new DispatchData();
            targetObj.id = id;
            targetObj.viewDispatch.dispatchId = id;
            targetObj.target = target;
            targetObj.targetCode = target.toString();
            if (dqoiDisplaySettings) {
                targetObj.dqoiDisplaySettings = dqoiDisplaySettings;
            }
            
            this.openDQOI.next(targetObj);
        }
        else {
            //this.openDQOI.next(id);
        }
    }

    private openDispatchQV = new Subject<any>();
    openDispatchQV$ = this.openDispatchQV.asObservable();

    private openDispatchQVSettings = new Subject<DispatchQVSettingsInput>();
    openDispatchQVSettings$ = this.openDispatchQVSettings.asObservable();

    openDispatchQVPopup(dispatch: any, settings?: DispatchQVSettingsInput) {
        this.openDispatchQV.next(dispatch);
        if (settings) {
            this.openDispatchQVSettings.next(settings);
        }
    }

    private openOrderQV = new Subject<any>();
    openOrderQV$ = this.openOrderQV.asObservable();

    openOrderQVPopup(order) {
        this.openOrderQV.next(order);
    }

    private openDispatchRefrigQV = new Subject<any>();
    openDispatchRefrigQV$ = this.openDispatchRefrigQV.asObservable();
    openDispatchRefrigQVPopup(dispatch) {
        this.openDispatchRefrigQV.next(dispatch);
    }

    getDashboardLayoutsByUser() {
        let url_call: string = this.baseUrl + "getDashboardLayoutsByUser";
        return this._http.get(url_call);
    }
    getDashboardLayout(layoutId: any) {
        let url_call: string = this.baseUrl + "getDashboardLayout";
        return this._http.get(url_call);
    }
    getStatusCountsByUser(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetStatusCountsByUser";
        return this._http.get(url_call, options);
    }
    getDispatchReviewStatusCountsByUser(search: WidgetSearch): Observable<any> {
        search.active = false;
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDispatchReviewStatusCountsByUser";
        return this._http.get(url_call, options);
    }
    getOrderReviewStatusCountsByUser(search: WidgetSearch): Observable<any> {
        search.active = false;
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetOrderReviewStatusCountsByUser";
        return this._http.get(url_call, options);
    }
    getDashboardOpenQuotes(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardOpenQuotes";
        return this._http.get(url_call, options);
    }
    getDashboardOpenQuotesGrid(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardOpenQuotesGrid";
        return this._http.get(url_call, options);
    }
    getQuoteStatusSummary(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetQuoteStatusSummary";
        return this._http.get(url_call, options);
    }
    getDashboardQuotesPending(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardQuotesPendingApproval";
        return this._http.get(url_call, options);
    }
    getDashboardQuotesPendingGrid(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardQuotesPendingApprovalGrid";
        return this._http.get(url_call, options);
    }
    getOpenContracts(search: WidgetSearch) {
        search.constructionDispatches = true;
        search.active = false;
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetStatusCountsByUser";
        return this._http.get(url_call, options);
    }
    getPendingChangeOrders(search: WidgetSearch) {
        search.constructionDispatches = true;
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetPendingChangeOrders";
        return this._http.get(url_call, options);
    }
    getDashboardInvoiceApprovals(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardInvoiceApprovals";
        return this._http.get(url_call, options);
    }
    GetMonthEndDrawRecosts(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetMonthEndDrawRecosts";
        return this._http.get(url_call, options);
    }
    getDashboardInvoiceApprovalsGrid(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardInvoiceApprovalsGrid";
        return this._http.get(url_call, options);
    }
    getMonthEndDrawRecostsGrid(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetMonthEndDrawRecostsGrid";
        return this._http.get(url_call, options);
    }

    reCostingOfJobs(model: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "ReCostingOfJobs";
        return this._http.put(url_call, model, { headers });
    }
    getDashboardActiveInvoiceDisputesGrid(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardActiveInvoiceDisputesGrid";
        return this._http.get(url_call, options);
    }
    getDashboardCreditMemoApprovalsGrid(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardCreditMemoApprovalsGrid";
        return this._http.get(url_call, options);
    }
    getDashboardCreditMemoApprovalsGridV2(search: WidgetSearch) {
        if (this.creditMemoUser) {
            search.userCreditMemoApprLimit = this.creditMemoUser.creditLimit;
        }
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl_v2 + "credit-memo/grid";
        return this._http.post(url_call, search, { headers });
    }
    getDashboardDispatchEquipmentHistory(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardDispatchEquipmentHistory";
        return this._http.get(url_call, options);
    }
    getDashboardDispatchStatusGauge(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardDispatchStatusGauge"
        return this._http.get(url_call, options);
    }
    getDashboardQuotesPendingApproval(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardQuotesPendingApproval";
        return this._http.get(url_call, options);
    }
    getDashboardOpenVendorReturns(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardOpenVendorReturns";
        return this._http.get(url_call, options);
    }
    getDashboardPurchaseOrderSummary(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardPurchaseOrderSummary";
        return this._http.get(url_call, options);
    }
    getDashboardZeroDollarOrders(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardZeroDollarOrders";
        return this._http.get(url_call, options);
    }
    getDashboardInvoiceSalesSummary(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardInvoiceSalesSummary";
        return this._http.get(url_call, options);
    }
    getDashboardInvoiceSalesSummaryDetails(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardInvoiceSalesSummaryDetails";
        return this._http.get(url_call, options);
    }
    getDashboardMonthlyInvoiceSalesDetail(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardMonthlyInvoiceSalesDetail";
        return this._http.get(url_call, options);
    }
    getDashboardMonthlyInvoiceSalesDetailGrid(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardMonthlyInvoiceSalesDetailGrid";
        return this._http.get(url_call, options);
    }
    getDashboardKpi(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardKpi";
        return this._http.get(url_call, options);
    }
    getDashboardTechHoursSummary(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardTechHoursSummary";
        return this._http.get(url_call, options);
    }
    getDashboardTechStatSummary(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardTechStatSummary";
        return this._http.get(url_call, options);
    }
    getDashboardAccountReceivablesSummary(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardAccountReceivablesSummary";
        return this._http.get(url_call, options);
    }
    getDashboardShowCustomerStatistics(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl_v2 + "GetDashboardShowCustomerStatistics";
        return this._http.get(url_call, options);
    }
    getDashboardRefTrackingGauge(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardRefTrackingGauge"
        return this._http.get(url_call, options);
    }
    getDashboardRefTrackingGauge_v2(search: DispatchRefTrackSearch) {
        let url_call: string = this.baseUrl_v2 + "GetDashboardRefTrackingGauge"
        return this._http.post(url_call, search);
    }
    getDashboardActiveInvoiceDisputes(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardActiveInvoiceDisputes"
        return this._http.get(url_call, options);
    }
    getDashboardCreditMemoApprovals(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardCreditMemoApprovals"
        return this._http.get(url_call, options);
    }
    getDashboardCreditMemoApprovalsSearch(search: WidgetSearch) {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl_v2 + "credit-memo/chart"
        return this._http.post(url_call, search, { headers });
    }
    getDashboardRefTrackingDetails(search: WidgetSearch) {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetDashboardRefTrackingDetails"
        return this._http.get(url_call, options);
    }
    getDashboardRefTrackingDetails_v2(search: DispatchRefTrackSearch) {
        let url_call: string = this.baseUrl_v2 + "GetDashboardRefTrackingDetails"
        return this._http.post(url_call, search);
    }
    getCPDispatchesNeedingParts(search: WidgetSearch): Observable<any> {
        var s_search = JSON.stringify(search);
        let options = this.getOptionsU('', "widgetsearch", s_search);
        let url_call: string = this.baseUrl + "GetCPDispatchesNeedingParts";
        return this._http.get(url_call, options);
    }
    GetDashboardLayoutsByUsers() {
        let url_call: string = this.baseUrl + "GetDashboardLayoutsByUsers";
        return this.get(url_call);
    }
    GetDashboardLayout(id: string) {
        let url_call: string = this.baseUrl + "GetDashboardLayout/" + id;
        return this.get(url_call);
    }
    SaveDashboardLayout(layout: DashboardLayoutsBusParam) {
        let body = {
            "LayoutId": layout.layoutId ? layout.layoutId : null,
            "Layout": layout.layout ? JSON.stringify(layout.layout) : "",
            "LayoutName": layout.layoutName ? layout.layoutName : "",
            "DefaultLayout": layout.defaultLayout ? layout.defaultLayout : false
        };
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "SaveDashboardLayout";
        return this._http.put(url_call, body, { headers });
    }
    saveCreditMemoWidgetUser(data: CreditMemoWidgetUser) {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl_v2 + "credit-memo/user";
        return this._http.post(url_call, data, { headers });
    }

    getCreditMemoWidgetUser(userId: string) {
        let url_call: string = this.baseUrl_v2 + "credit-memo/user/" + userId;
        return this._http.get(url_call);
    }

    getCreditMemoWidgetUserGrid() {
        let url_call: string = this.baseUrl_v2 + "credit-memo/user/grid";
        return this._http.get(url_call);
    }

    deleteCreditMemoWidgetUser(userId: string) {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl_v2 + "credit-memo/user/" + userId + "/delete";
        return this._http.post(url_call, null, { headers });
    }

    getDivisions() {
        let url_call: string = this.baseUrl_v2 + "divisions";
        return this._http.get(url_call);
    }
    //DeleteDashboardLayout(layoutId: string) {
    //    let body = {
    //        "LayoutId": layoutId
    //    };
    //    let headers = this.getHeaders();
    //    let url_call: string = this.baseUrl + "DeleteDashboardLayout";
    //    return this._http.put(url_call, body, { headers });
    //}
    DeleteDashboardLayout(layoutId: any): Observable<any> {
        let headers = this.getHeaders();
        let url_call: string = this.baseUrl + "DeleteDashboardLayout/" + layoutId;
        return this._http.delete(url_call, { headers });
    }
    getDashboardQuery(query: DashboardQueries, search: WidgetSearch): Observable<any> {
        switch (query) {
            case DashboardQueries.openDispatches:
                return this.getStatusCountsByUser(search);
            case DashboardQueries.dispatchReviewLite:
                return this.getDispatchReviewStatusCountsByUser(search);
            case DashboardQueries.orderReviewLite:
                return this.getOrderReviewStatusCountsByUser(search);
            case DashboardQueries.dispatchreftracking:
                return this.getDashboardRefTrackingGauge(search);
            case DashboardQueries.dispatchreftracking_v2:
                let newSearch = new DispatchRefTrackSearch(search);
                return this.getDashboardRefTrackingGauge_v2(newSearch);
            case DashboardQueries.openQuotes:
                return this.getDashboardOpenQuotes(search);
            case DashboardQueries.quoteSummary:
                return this.getQuoteStatusSummary(search);
            case DashboardQueries.quotesPending:
                return this.getDashboardQuotesPending(search);
            case DashboardQueries.openContracts:
                return this.getOpenContracts(search);
            case DashboardQueries.invoiceApprovals:
                return this.getDashboardInvoiceApprovals(search);

            case DashboardQueries.monthEndDrawRecost:
                return this.GetMonthEndDrawRecosts(search);
            case DashboardQueries.dispatchEquipmentHistory:
                return this.getDashboardDispatchEquipmentHistory(search);
            case DashboardQueries.dispatchStatusGauge:
                return this.getDashboardDispatchStatusGauge(search);
            case DashboardQueries.quotesPendingApproval:
                return this.getDashboardQuotesPendingApproval(search);
            case DashboardQueries.openVendorReturns:
                return this.getDashboardOpenVendorReturns(search);
            case DashboardQueries.purchaseOrderSummary:
                return this.getDashboardPurchaseOrderSummary(search);
            case DashboardQueries.zeroDollarOrders:
                return this.getDashboardZeroDollarOrders(search);
            case DashboardQueries.invoiceSalesSummary:
                return this.getDashboardInvoiceSalesSummary(search);
            case DashboardQueries.monthlyInvoiceSalesDetail:
                return this.getDashboardMonthlyInvoiceSalesDetail(search);
            case DashboardQueries.kpi:
                return this.getDashboardKpi(search);
            case DashboardQueries.techHoursSummary:
                return this.getDashboardTechHoursSummary(search);
            case DashboardQueries.techStatSummary:
                return this.getDashboardTechStatSummary(search);
            case DashboardQueries.accountReceivablesSummary:
                return this.getDashboardAccountReceivablesSummary(search);
            case DashboardQueries.showCustomerStatistics:
                return this.getDashboardShowCustomerStatistics(search);
            case DashboardQueries.activeInvoiceDispute:
                return this.getDashboardActiveInvoiceDisputes(search);
            case DashboardQueries.creditMemoApproval:
                {
                    if (this.featureFlagCreditMemoApprovalWidgetHighPriorityChangesPt2 && this.creditMemoUser) {
                        search.userCreditMemoApprLimit = this.creditMemoUser.creditLimit;
                        if (!search.divisionIds || search.divisionIds.length == 0) {
                            search.divisionIds = this.creditMemoUser.divisionIds;
                        }
                        if (!search.regionIds || search.regionIds.length == 0) {
                            search.regionIds = this.creditMemoUser.regionIds;
                        }
                        return this.getDashboardCreditMemoApprovalsSearch(search);
                    } else {
                        return this.getDashboardCreditMemoApprovals(search);
                    }
                }
            case DashboardQueries.zuggitCpDispatchNeedsParts:
                return this.getCPDispatchesNeedingParts(search);
            case DashboardQueries.pendingChangeOrders:
                return this.getPendingChangeOrders(search);

        }
    }

    //componentFactory(component: FactoryComponents): ComponentFactory<any> {
    //    var factory: ComponentFactory<any> = null;
    //    switch (component) {
    //        case FactoryComponents.Dispatches:
    //            factory = this.resolver.resolveComponentFactory(DispatchGridComponent);
    //            break;
    //        case FactoryComponents.Quotes:
    //            factory = this.resolver.resolveComponentFactory(QuotesGridComponent);
    //            break;
    //        case FactoryComponents.DQOI:
    //            factory = this.resolver.resolveComponentFactory(DQOIComponent);
    //            break;
    //    }
    //    return factory;
    //}
}
